import { healthStatusE } from './health-status';
import { runningStatusE } from './running-status';

/**
 * 极简模式各菜单Path
 */
export const SIMPLE_MODE_PATH = {
    HOME: '/simple/home',
    LUN: '/simple/block/lun',
    HOST: '/simple/block/hosts',
    FILE_SERVICE: '/simple/file-service',
    PROTECTION: '/simple/protection',
    ALARMS_AND_EVENTS: '/simple/alarms-and-events',
    SCHEDULE_REPORT: '/simple/monitor/schedule-report',
    HARDWARE: '/simple/system/hardware',
    SETTINGS: '/simple/settings',
};

export enum SimpleModeStateColor {
    NORMAL = '#7ADFA0',
    WARNING = '#FDCA5A',
    ERROR = '#F45C5E'
}

export const SIMPLE_MODE_HEALTH_STATUS_OPTIONS = {
    [healthStatusE.Normal.value]: SimpleModeStateColor.NORMAL,
    [healthStatusE.Fault.value]: SimpleModeStateColor.ERROR,
    [healthStatusE.NoRedundantLink.value]: SimpleModeStateColor.WARNING,
    [healthStatusE.OFFLINE.value]: SimpleModeStateColor.WARNING,
};

export const SIMPLE_MODE_RUNNING_STATUS_OPTIONS = {
    [runningStatusE.LINK_UP.value]: SimpleModeStateColor.NORMAL,
    [runningStatusE.LINK_DOWN.value]: SimpleModeStateColor.WARNING,
    [runningStatusE.Online.value]: SimpleModeStateColor.NORMAL,
    [runningStatusE.Disabled.value]: SimpleModeStateColor.ERROR,
    [runningStatusE.Connecting.value]: SimpleModeStateColor.NORMAL,
};

export enum PreferredPathSetting {
    YES = '1',
    NO = '0'
}

/**
 * 用户偏好模式
 */
export enum PreferenceModeE {
    /**
     * 偏好标准模式
     */
    Standard = 0,
    /**
     * 偏好极简模式
     */
    Simple = 1
}
